import React, { Component } from "react"
import intl from "react-intl-universal"
import { Menu, Avatar } from "antd"
import 'antd/dist/antd.min.css'
import "./nav.css"
import {
    PoweroffOutlined,
    DownOutlined
} from '@ant-design/icons'

import DocCookie from "../../common/Cookie"

const { SubMenu } = Menu


class ConsoleNav extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    handleClickMenu = e => {
        console.log('e', e)
    }

    onVisibleChange (e) {
        console.log("onVisibleChange", e)
    }

    // 退出事件
    logout () {
        let domain = process.env.REACT_APP_COOKIE_DOMAIN,
            url = process.env.REACT_APP_OLD_CONSOLE_URL
        console.log(DocCookie.keys())
        DocCookie.keys().forEach(function (key) {
            DocCookie.removeItem(key, '/', domain)
        })

        window.location.href = url + '?refer=logout'
    }

    // 控制下拉菜单
    userMenuDrop (item) {
        if (item.url === '/site/logout') {
            return (<span onClick={this.logout} style={{ color: '#fc5b5f' }}><PoweroffOutlined />&nbsp; {item.title}</span>)
        } else if (item.url === '/#/order/list') {
            return (<a href={process.env.REACT_APP_BASE_URL + item.url}>{item.title}</a>)
        } else {
            return (<a href={process.env.REACT_APP_OLD_CONSOLE_URL + item.url}>{item.title}</a>)
        }
    }


    render () {
        let that = this

        return (
            <div className="header">
                <a className="logo" href={process.env.REACT_APP_OLD_CONSOLE_URL}>
                    <img src="https://livedatacdn.ilivedata.com/images/big/zh-CN/logo-blue.png" alt="" />
                </a>

                <div className="header-right">
                    <div className="nav-op">
                        {/*总览*/}
                    </div>

                    <div style={{ display: 'flex' }}>
                        <div style={{ paddingRight: '11px', cursor: 'pointer' }}>
                            <a href="https://docs.ilivedata.com/" target="_blank" rel="noopener noreferrer">{intl.get('sys.docs')}</a>
                        </div>
                        <div><span style={{ border: '1px solid rgba(0, 0, 0, 0.05)', height: '24px', marginLeft: '10px' }}></span></div>
                        <div>
                            <Menu key="userMenu" mode="horizontal" onClick={this.handleClickMenu}>
                                <SubMenu key="userMenuDrop" popupClassName="user-menu-top"
                                    title={
                                        <span>
                                            <Avatar size="small" src="/assets/image/user/default_avatar.png" />
                                            <DownOutlined style={{ marginLeft: '8px', fontSize: '9px' }} />
                                        </span>
                                    }>
                                    {
                                        that.props.userMenuList.map((item) =>
                                            <Menu.Item key={item.key} style={{ textAlign: 'center' }}>
                                                {that.userMenuDrop(item)}
                                            </Menu.Item>
                                        )
                                    }
                                </SubMenu>
                            </Menu>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


export default ConsoleNav
